module.exports = __webpack_public_path__ + "ca54fe11d3450f409c5f4df191870a83.svg";